import type { TrackingLabels } from '@shared/tracking/TrackingLabels.ts';
import type { TrackingFeature } from '@shared/types/tracking.ts';
import type { BlackFridaySliderItem, ProductItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import { isBlackFridaySliderItem } from '@tilelist/domain/composition/TileListitem.ts';

export const BLACK_FRIDAY_SLIDER_FEATURE_ID = 'blackfriday_slider';
const SLIDER_TYPE = 'blackfriday_slider';
const BLACK_FRIDAY_SLIDER_LIST_FEATURE = 'blackFridaySlider';

export function sliderTileFeatureId(position: number): string {
    return `${BLACK_FRIDAY_SLIDER_FEATURE_ID}_tile_${position}`;
}

export function blackFridaySliderLabels() {
    return { san_ListSliderType: [SLIDER_TYPE], 'wk.san_ListFeatures': [BLACK_FRIDAY_SLIDER_LIST_FEATURE] };
}

/**
 *
 *
 */
export function listFeaturesLabels(items: TileListItem[] = []): { 'wk.san_ListFeatures'?: string[] } {
    const slider = items.find(isBlackFridaySliderItem);
    if (slider?.state === 'pending') return {};

    return { 'wk.san_ListFeatures': [slider?.state === 'ready' ? BLACK_FRIDAY_SLIDER_LIST_FEATURE : 'none'] };
}

/*                                                                  */
export function blackFridaySliderLoadedLabels(slider: BlackFridaySliderItem) {
    return slider.state === 'ready' ? blackFridaySliderLabels() : { 'wk.san_ListFeatures': ['none'] };
}

/*                                                               */
export function blackFridaySliderFeatures(slider: BlackFridaySliderItem): TrackingFeature[] {
    if (slider.state !== 'ready') return [];

    return [
        {
            id: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            name: 'BlackFridaySlider',
            status: 'loaded',
        },
        ...slider.items.map((item): TrackingFeature => ({
            id: sliderTileFeatureId(item.localListPosition),
            name: 'BlackFridaySlider-Tile',
            position: item.localListPosition,
            variationId: item.product.bestVariationId,
            status: 'loaded',
            parentId: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            labels: {
                ...(item.product.productType === 'sponsored' ? item.product.featureTracking : undefined),
                san_ProductType: [item.product.productType],
            },
        })),
    ];
}

export function blackFridaySliderClickLabels(base: TrackingLabels, item: ProductItem): TrackingLabels {
    return {
        ...base,
        san_Interaction: 'black_friday_slider_product_tile',
        'wk.san_ProductType': `slider_${item.product.productType}`,
        'wk.san_ItemSource': 'blackFridaySlider',
        'wk.san_ItemPosition': item.localListPosition,
    };
}
